import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-cloude-white",
  "use": "app-icon-cloude-white-usage",
  "viewBox": "0 0 24 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 18\" id=\"app-icon-cloude-white\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M12 0a6 6 0 015.996 5.775L18 6a6 6 0 110 12H6A6 6 0 116 6l.004-.225A6 6 0 0112 0zm0 2C9.914 2 8.192 3.6 8.016 5.616l-.012.196L7.964 8H6a4 4 0 00-.2 7.995L6 16h12a4 4 0 00.2-7.995L18 8h-1.964l-.039-2.151A4 4 0 0012 2z\" fill=\"#FFF\" fill-rule=\"nonzero\" /><path stroke=\"#FFF\" d=\"M5 11.5h4L11 8l2 6 1-2.5h5\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol